import React from "react";
import { CustomAutocomplete } from "./custom-autocomplete";
import { AutocompleteOptions } from "@algolia/autocomplete-core";
import { AutocompleteItem } from "./types";

import "@algolia/autocomplete-theme-classic/dist/theme.css";
import "./autocomplete.css";

interface AutocompleteProps extends Partial<AutocompleteOptions<AutocompleteItem>> {
  initialStateQuery: string | undefined;
  onSubmitCallback: Function;
  onResetCallback?: Function;
}

export function Autocomplete(props: AutocompleteProps) {
  const { initialStateQuery, onSubmitCallback, onResetCallback } = props;
  return (
    <CustomAutocomplete
      placeholder="Sökord, verktygsnamn, artiklar"
      openOnFocus={true}
      debug={false}
      initialStateQuery={initialStateQuery}
      onSubmitCallback={onSubmitCallback}
      onResetCallback={onResetCallback}
    />
  );
}
